// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit-sensor form .input-form-wrapper[data-v-edcd675e]{margin-bottom:16px}.edit-sensor form .input-form-wrapper[data-v-edcd675e]:last-child{margin-bottom:0}.edit-sensor form .input-form-wrapper label[data-v-edcd675e]{font-weight:700}.edit-sensor form .input-form-wrapper input[data-v-edcd675e]{padding:6px 8px;width:100%;height:35px;-webkit-box-sizing:border-box;box-sizing:border-box;border:1px solid #ccc;border-radius:4px}", ""]);
// Exports
module.exports = exports;
